module.exports = __webpack_public_path__ + "assets/img/title-2a083084.png";